import React from 'react'
import { ToggleButton, Tooltip } from '@mui/material'

// ToggleButtonGroup clones its direct children to inject selected/onChange,
// so a tooltip can't simply wrap a ToggleButton — this forwards those props
// through (and the span lets the tooltip work on a disabled button).
const TooltipToggleButton = ({ title, ...props }) => (
  <Tooltip title={title || ''}>
    <span style={{ display: 'flex' }}>
      <ToggleButton {...props} />
    </span>
  </Tooltip>
)

export default TooltipToggleButton
